import initModal from "./initializers/Modal.js";
import initUser from "./initializers/User.js";
import initRcog2027Registration from "./initializers/Rcog2027Registration.js";

const initApplication = () => {
  initModal();
  initUser();
  initRcog2027Registration();
};

export default initApplication;
